"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  defaultLatitude: 35.6922055,
  defaultLongitude: 139.6874118,
  defaultZoom: 15
};


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/constants/map.js
// module id = 522
// module chunks = 0